<app-styled-banner [banner]='banner'></app-styled-banner>
<app-music-festivals [festivals]="festivals"></app-music-festivals>
